"use client";

import React from "react";
import Footer from "@/components/layout/Footer";
import ContactSection from "./components/ContactSection";
import { useContactPageData } from "./hooks/useContactPageData";

/**
 * ContactPage Component
 * Main component for the Contact page that composes all sections
 */
export default function ContactPage() {
  const {
    contactInfo,
    loading,
    error,
  } = useContactPageData();

  return (
    <div className="">
      {/* Main content area */}
      <div className="bg-white min-h-screen flex items-center justify-center">
        <ContactSection
          contactInfo={contactInfo}
          loading={loading}
          error={error}
        />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
